<template>
  <component :is="htmlTag"
    class="m-form"
    :class="[margin]"
    :style="{
      '--label-width': `${labelWidth}`
    }"
  >
    <span v-if="label" class="m-form-label mr-2" :class="[labelMargin]" :style="{ alignSelf: `${flexAlign}` }">{{ label }}</span>
    <span v-if="isPrint && typeof value === 'boolean'" class="w-full">
      <feather-icon icon="CheckIcon" style="width:21px; height: 21px;" />
    </span>
    <span v-else-if="isPrint" class="w-full"><slot name="print">{{ value }}</slot></span>
    <div v-else class="w-full"><slot></slot></div>
  </component>
</template>

<script>
export default {
  name: 'MForm',
  props: {
    label: String,
    value: String | Number | Boolean,
    margin: {
      type: String,
      default: () => {
        return 'mr-4'
      }
    },
    htmlTag: {
      type: String,
      default: () => {
        return 'label'
      }
    },
    labelWidth: { type: String, default: () => { return '100px' }},
    labelMargin: { type: String, default: () => { return 'm-0' }},
    flexAlign: { type: String, default: () => { return 'center' }}
  },
  computed: {
    isPrint () {
      return this.$store.state.ui.isPrint
    }
  }
}
</script>

<style lang="scss" scoped>
.m-form {
  display: flex;
  align-items: center;
  justify-content: start;
  min-height: 2.4rem;

  & > .m-form-label {
    min-width: var(--label-width);
    width: var(--label-width);
    align-self: center;
  }
}
</style>
